import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchScenarioVoiceMap,
  scenarioVoiceMapQueryKey,
  updateScenarioVoiceMap,
  type ScenarioVoiceMapResponse,
  type VoiceAssignment,
} from '../../../../features/scenarios/api';

/**
 * 話者と声の対応表 (GET /scenarios/<id>/voice-map・§10.7.3)。声のセクションと登場人物の区画で共有する。
 * 台本 (声の行の話者) を保存したとき・声の生成が終わったときに呼び出し側が invalidate する。
 */
export function useScenarioVoiceMap(scenarioId: string | null | undefined, enabled = true) {
  return useQuery<ScenarioVoiceMapResponse>({
    queryKey: scenarioVoiceMapQueryKey(scenarioId ?? ''),
    queryFn: () => fetchScenarioVoiceMap(scenarioId as string),
    enabled: !!scenarioId && enabled,
    staleTime: 30 * 1000,
  });
}

/** 対応表を保存する (部分マージ・null で割り当てを外す。応答で query のキャッシュを置き換える)。 */
export function useUpdateScenarioVoiceMap(scenarioId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch: Record<string, VoiceAssignment | null>) => updateScenarioVoiceMap(scenarioId, patch),
    onSuccess: (data) => {
      queryClient.setQueryData(scenarioVoiceMapQueryKey(scenarioId), data);
    },
  });
}
